import { useConfiguration } from 'common/hooks/useConfiguration';
import { ReactElement } from 'react';
import { Route } from 'react-router';
import { SwitchWithNotFound } from '../../containers/SwitchWithNotFound';
import { NotFoundView } from '../../views/errors/NotFound.view';
import { UsersView } from '../../views/home/admin/Users.view';
import { WorkspacesView } from '../../views/home/admin/Workspaces.view';
import { Home } from '../config/Home';

export const AdminRoute = (): ReactElement => {
  const config = useConfiguration();
  return (
    <SwitchWithNotFound notFound={<NotFoundView />}>
      <Route path={Home.Admin.Users.Path}>
        <UsersView />
      </Route>
      {!config.appConfig.runLocally && (
        <Route path={Home.Admin.Workspaces.Path}>
          <WorkspacesView />
        </Route>
      )}
    </SwitchWithNotFound>
  );
};
